/* tslint:disable */
/* eslint-disable */
/**
 * Notification service API
 * Service for handling and managing notifications
 *
 * The version of the OpenAPI document: 1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface NewAutotodoRequestDto
 */
export interface NewAutotodoRequestDto {
    /**
     * User Id
     * @type {string}
     * @memberof NewAutotodoRequestDto
     */
    userId: string;
    /**
     * Text id for notification message
     * @type {string}
     * @memberof NewAutotodoRequestDto
     */
    symbolicTextId: string;
    /**
     * any additional notification parameters
     * @type {{ [key: string]: string; }}
     * @memberof NewAutotodoRequestDto
     */
    parameters?: { [key: string]: string; };
}

/**
 * Check if a given object implements the NewAutotodoRequestDto interface.
 */
export function instanceOfNewAutotodoRequestDto(value: object): boolean {
    if (!('userId' in value)) return false;
    if (!('symbolicTextId' in value)) return false;
    return true;
}

export function NewAutotodoRequestDtoFromJSON(json: any): NewAutotodoRequestDto {
    return NewAutotodoRequestDtoFromJSONTyped(json, false);
}

export function NewAutotodoRequestDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): NewAutotodoRequestDto {
    if (json == null) {
        return json;
    }
    return {
        
        'userId': json['userId'],
        'symbolicTextId': json['symbolicTextId'],
        'parameters': json['parameters'] == null ? undefined : json['parameters'],
    };
}

export function NewAutotodoRequestDtoToJSON(value?: NewAutotodoRequestDto | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'userId': value['userId'],
        'symbolicTextId': value['symbolicTextId'],
        'parameters': value['parameters'],
    };
}

